<template>
  <div class="">
    <div class="row">
      <div class="col-lg-12">
        <div class="testResultContainer" :class="this.resultID">
          <div class="content">
            <div class="">
              <h3 v-if="!moreInfo">Congratulations!</h3>
              <h5 v-if="!moreInfo">{{ result.message }}</h5>
              <p v-if="!moreInfo">{{result.description}}</p>
              <p v-else>{{result.more}}</p>
              
              <a v-if="moreInfo" href="https://www.yearofengineering.gov.uk/feature/843" target="_blank" class="moreButtonContainer">Meet the real-life Super Heroes</a>
              <a v-else @click="moreInfo = true" class="moreButtonContainer">Read on...</a>

            </div>
          </div>
        </div>
        <div v-if="moreInfo" class="moreOptionsRow">
          <div class="saveTestHolder">
            <a :href="'./download/certificate_' + this.result.id + '.pdf'" :download="'certificate' + result.name " class="gameLink gameLink--jump">Download your Super Hero certificate<img src="../assets/images/certificates/download_button.svg"></a>
            <!-- <a class="gameLink gameLink--jump"><img src="../assets/images/certificates/download_button.svg"></a> -->
          </div>
          <div class="replayGamesHolder">
            <p>Replay puzzles</p>
            <router-link class="gameLink gameLink--puzzle" to="/puzzle?replay=true"><img src="../assets/images/certificates/puzzle_button.svg"></router-link>
            <router-link class="gameLink gameLink--tower" to="/tower?replay=true"><img src="../assets/images/certificates/tower_button.svg"></router-link>
            <router-link class="gameLink gameLink--jump" to="/jump?replay=true"><img src="../assets/images/certificates/jump_button.svg"></router-link>
          </div>
        </div>

        <!-- <p>Get your certificate here:<br><a ><img :src="getImgUrl(result.image)"></a></p> -->
        
        
        
        <!-- <a class="genericButton" @click="restartTest()">Start Again</a> -->

        <img src="../assets/images/certificates/Download_Replay.png" alt="Preloaded Image" class="preloadImage">
      </div>
    </div>
  </div>
</template>

<script>
import resultData from '../assets/json/results.json'
export default {
  data() {
    return {
      resultID: null,
      nextLink: 'one',
      moreInfo: false,
      result: {}
    }
  },
  mounted () {

    if (this.$route.query.replay) {
      this.moreInfo = true
    }

    if (this.allAnswers.length > 1) {
      this.result = resultData[this.allAnswers.sort((a,b) => this.allAnswers.filter(v => v===a).length - this.allAnswers.filter(v => v===b).length ).pop()]

      this.resultID = 'testResultContainer--' + this.result.id
    } else {
      this.restartTest()
    }

    this.$ga.event({
      eventCategory: 'result',
      eventAction: 'finished',
      eventLabel: this.result.id,
      eventValue: 1
    })
  },
  computed: {
    totalProgress () {
      return this.$store.getters.StoreQuestionData.total
    },
    allAnswers () {
      return this.$store.getters.StoreQuestionData.questionArray
    }
  },
  methods: {
    removeItemFromArray (array, element) {
      const index = 1
      if (index !== -1) {
        array.splice(index, 1)
      }
    },
    // getImgUrl(imageName) {
    //   var images = require.context('../assets/images/certificates/pdf', false)
    //   console.log(images)
    //   console.log(images('./hulk.png'))
    //   console.log('.download/certificate_' + this.result.id + '.pdf')
    //   return images('./hulk.png')
    //   // return images('./certificate_' + this.result.id + '.pdf')
    // },
    restartTest () {
      this.$store.dispatch('clearData')
      this.$router.push('/' + this.nextLink)
    }
  }
}
</script>


